// extracted by mini-css-extract-plugin
export default {"availableCount":"Block_availableCount__X2xwr","invitedCount":"Block_invitedCount__JaOxs","waitingTime":"Block_waitingTime__uodT-"};